import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { cloneLoop } from '@utiljs/clone';
import classNames from 'classnames';
import { toggleClass } from '@utiljs/dom';

var Tree = /*#__PURE__*/function (_React$Component) {
  _inherits(Tree, _React$Component);

  var _super = _createSuper(Tree);

  function Tree(props) {
    var _this;

    _classCallCheck(this, Tree);

    _this = _super.call(this, props); // 缓存 props 选中的节点，用于改变父节点的 checked 状态

    _this.tempDefaultCheckedNode = [];

    _this.initStateTree = function (treeData) {
      var data = _this.props.data;
      var cData = cloneLoop(treeData || data);

      _this.factorialNode(cData);

      _this.updateParentChecked();

      _this.updateState(cData);
    };

    _this.updateParentChecked = function () {
      _this.tempDefaultCheckedNode.forEach(function (item) {
        _this.setCheckedRelationNode(item, true);
      });
    };

    _this.isExpanded = function (item) {
      var _this$props = _this.props,
          defaultExpandAll = _this$props.defaultExpandAll,
          defaultExpandedKeys = _this$props.defaultExpandedKeys,
          nodeKey = _this$props.nodeKey,
          nodeChildren = _this$props.nodeChildren;
      var hasChild = nodeChildren && item[nodeChildren] && item[nodeChildren].length;
      var needExpandNode = defaultExpandedKeys && defaultExpandedKeys.length && defaultExpandedKeys.indexOf(item[nodeKey]) > -1;

      if (hasChild) {
        // needExpandNode be superior to defaultExpandAll
        if (needExpandNode || defaultExpandAll) {
          return true;
        }
      }

      return false;
    }; // factorial node


    _this.factorialNode = function (node, parent, selectedNode) {
      var _this$props2 = _this.props,
          showCheckbox = _this$props2.showCheckbox,
          lazy = _this$props2.lazy,
          nodeChildren = _this$props2.nodeChildren,
          nodeKey = _this$props2.nodeKey,
          selectedKey = _this$props2.selectedKey,
          selectedKeys = _this$props2.selectedKeys;

      if (node && node.length) {
        node.forEach(function (item, index) {
          // set extra props
          item.level = parent ? parent.level + 1 : 0;
          item.hasChild = !!(item[nodeChildren] && item[nodeChildren].length);
          item.hasCheckbox = showCheckbox || false;
          item.isRoot = !parent;
          item.isDisabled = !!item.disabled;
          item.isLastNode = !(item[nodeChildren] && item[nodeChildren].length);
          item.isLeaf = !!(lazy && !item.hasChild && item.isLeaf);
          item.isExpanded = node.isExpanded || _this.isExpanded(item);
          item.parent = parent || '';
          item.spckey = parent ? "".concat(parent.spckey, "_").concat(index) : "".concat(index);
          item.isChecked = selectedKeys.indexOf(item[nodeKey]) >= 0 || !!(parent && parent.isChecked);
          item.isSelected = selectedKey === item[nodeKey];

          if (selectedKeys.indexOf(item[nodeKey]) >= 0) {
            _this.tempDefaultCheckedNode.push(item);
          } // if disabled must false


          if (item.isDisabled) {
            item.isChecked = false;
          } // fill flatstate


          _this.construcFlatState(item); // factorial init extra props


          _this.factorialNode(item[nodeChildren], item, selectedNode);
        });
      }
    }; // flat data


    _this.construcFlatState = function (node) {
      var flatState = _this.state.flatState;
      flatState.push(node);
    }; // common update relation nodes fn to isChecked and childCheckedStatus


    _this.updateRelationNodes = function (selectedStatus, selectedNode) {
      // set up/down node
      _this.setCheckedRelationNode(selectedNode, selectedStatus); // force render


      _this.updateState(_this.state.stateTree);
    }; // start update status


    _this.setCheckedRelationNode = function (node, checked) {
      // set current node status
      _this.setCurrNodeStatus(node, checked); // up set node status


      var parent = node.parent;

      if (parent) {
        _this.setParentNodeStatus(parent, checked);
      } // down set node status


      var nodeChildren = _this.props.nodeChildren;

      if (node[nodeChildren]) {
        _this.setChildNodeStatus(node[nodeChildren], checked);
      }
    }; // update current status


    _this.setCurrNodeStatus = function (node, checked) {
      node.isChecked = checked;

      if (node.isRoot && !checked || !checked) {
        node.childCheckedStatus = 2;
      }
    }; // update child status


    _this.setChildNodeStatus = function (child, checked) {
      var nodeChildren = _this.props.nodeChildren;
      child.forEach(function (ele) {
        ele.childCheckedStatus = 2;
        ele.isChecked = checked;

        if (ele[nodeChildren]) {
          _this.setChildNodeStatus(ele[nodeChildren], checked);
        }
      });
    }; // update parent status


    _this.setParentNodeStatus = function (parent, checked) {
      var nodeChildren = _this.props.nodeChildren;
      parent.childCheckedStatus = parent.isDisabled ? 2 : 3;

      if (parent[nodeChildren]) {
        var flag = [];
        parent[nodeChildren].forEach(function (ele) {
          if (ele.isChecked) {
            flag.push(ele.isChecked);
          }
        });

        _this.ctrHalfStatus(flag, parent, checked);
      }

      if (parent.parent) {
        _this.setParentNodeStatus(parent.parent, checked);
      }
    }; // control half selected


    _this.ctrHalfStatus = function (flag, node, checked) {
      var nodeChildren = _this.props.nodeChildren;

      if (flag.length === node[nodeChildren].length) {
        node.childCheckedStatus = 1;
        node.isChecked = true;
      } else if (checked || flag.length > 0 && flag.length < node[nodeChildren].length) {
        node.childCheckedStatus = node.isDisabled ? 2 : 3;
        node.isChecked = false;
      } else {
        node.childCheckedStatus = 2;
        node.isChecked = false;
      }
    }; // get selected node


    _this.getCheckedNodes = function () {
      var flatState = _this.state.flatState;
      var aNodes = flatState.filter(function (node) {
        return node.isChecked;
      });
      return aNodes;
    }; // set selected node


    _this.setCheckedNodes = function (selectNodes) {
      var flatState = _this.state.flatState;
      var aNodes = flatState.filter(function (node) {
        return selectNodes.indexOf(node.id) > -1;
      });
      aNodes.forEach(function (node) {
        _this.updateRelationNodes(true, node);
      });
    }; // clear selected


    _this.clearCheckedNodes = function () {
      var aNodes = _this.getCheckedNodes();

      aNodes.forEach(function (node) {
        _this.updateRelationNodes(false, node);
      });
    }; // selected all


    _this.checkAll = function () {
      var stateTree = _this.state.stateTree;
      stateTree.forEach(function (node) {
        _this.updateRelationNodes(true, node);
      });
    }; // clear all


    _this.clearAll = function () {
      _this.clearCheckedNodes();
    }; // handle checkbox change


    _this.handleCheckChange = function (evt, node) {
      var isChecked = evt.target.checked;

      _this.updateRelationNodes(isChecked, node); // onCheckChange hook


      var _this$props3 = _this.props,
          onCheckChange = _this$props3.onCheckChange,
          nodeKey = _this$props3.nodeKey,
          nodeLabel = _this$props3.nodeLabel;

      if (onCheckChange) {
        onCheckChange(cloneLoop({
          id: node[nodeKey],
          label: node[nodeLabel],
          isChecked: node.isChecked
        }), _this.getCheckedNodes());
      }
    }; // handle plan click


    _this.handleClick = function (evt, item) {
      var _this$props4 = _this.props,
          onNodeExpand = _this$props4.onNodeExpand,
          onNodeClick = _this$props4.onNodeClick,
          onNodeCollapse = _this$props4.onNodeCollapse,
          lazy = _this$props4.lazy,
          nodeKey = _this$props4.nodeKey,
          nodeLabel = _this$props4.nodeLabel,
          nodeChildren = _this$props4.nodeChildren; // isLeaf means lazy load Data

      if (lazy && item.isLeaf) {
        _this.execLazyLoad(evt, item);
      } // parent node


      if (item[nodeChildren] && item[nodeChildren].length) {
        var status = toggleClass(evt.currentTarget.parentNode, 'is-expanded');

        if (status === -1) {
          // onNodeExpand hook
          if (onNodeExpand) {
            onNodeExpand(cloneLoop({
              id: item[nodeKey],
              label: item[nodeLabel]
            }));
          }
        } else {
          // onNodeCollapse hook
          if (onNodeCollapse) {
            onNodeCollapse(cloneLoop({
              id: item[nodeKey],
              label: item[nodeLabel]
            }));
          }
        }
      } // onNodeClick hook


      if (onNodeClick) {
        // disabled node dont have click event
        if (!item.disabled) {
          onNodeClick(cloneLoop({
            id: item[nodeKey],
            label: item[nodeLabel],
            isSelected: true
          }));
        }
      }
    };

    _this.execLazyLoad = function (evt, item) {
      var lazyLoad = _this.props.lazyLoad;

      if (lazyLoad && typeof lazyLoad === 'function') {
        var evtNode = evt.currentTarget.firstChild; // update css

        evtNode.setAttribute('class', 'roo-tree-node-loading-icon'); // exec lazyLoadFn

        lazyLoad(item).then(function (newNode) {
          _this.appendNode(newNode);

          evtNode.setAttribute('class', 'roo-tree-node-expand-icon');
        });
      } else {
        console.error('[roo-react] lazyLoad must be a function!');
      }
    };

    _this.appendNode = function (item) {
      _this.resertCurrNode(item);

      var root = _this.getRootNode(item);

      var nodeChildren = _this.props.nodeChildren;

      _this.factorialNode(root[nodeChildren], root);

      _this.updateState(_this.state.stateTree);
    };

    _this.resertCurrNode = function (item) {
      item.isLeaf = false;
      item.isLastNode = false;
      item.hasChild = true;
      item.isExpanded = true; // 动态节点默认展开
    };

    _this.updateState = function (data) {
      _this.setState({
        stateTree: data
      });
    };

    _this.getRootNode = function (node) {
      if (node && !node.isRoot) {
        _this.getRootNode(node.parent);
      }

      return node;
    };

    _this.renderCheckbox = function (item) {
      var showCheckbox = _this.props.showCheckbox;

      if (!showCheckbox) {
        return null;
      }

      var checkedStyle = classNames('custom-checkbox', {
        'half-checked': item.childCheckedStatus === 3
      });
      return /*#__PURE__*/React.createElement("label", {
        className: "roo-checkbox"
      }, item.disabled ? /*#__PURE__*/React.createElement("input", {
        className: "tree-input",
        type: "checkbox",
        disabled: true
      }) : /*#__PURE__*/React.createElement("input", {
        className: "tree-input",
        type: "checkbox",
        checked: !!item.isChecked,
        onChange: function onChange(evt) {
          _this.handleCheckChange(evt, item);
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: checkedStyle
      }));
    };

    _this.renderLabel = function (item) {
      var _this$props5 = _this.props,
          nodeRender = _this$props5.nodeRender,
          nodeLabel = _this$props5.nodeLabel; // nodeRender func render label

      if (nodeRender && typeof nodeRender === 'function') {
        return nodeRender(item);
      } // default label


      return item[nodeLabel];
    }; // factorial render tree node


    _this.renderTree = function (data) {
      var _this$props6 = _this.props,
          nodeKey = _this$props6.nodeKey,
          nodeChildren = _this$props6.nodeChildren,
          lazy = _this$props6.lazy,
          className = _this$props6.className,
          style = _this$props6.style;
      if (!data || !data.length) return null;
      return data.map(function (node, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames('roo-tree-node', {
            'is-expanded': node.isExpanded,
            'is-leaf': !(node.isLeaf && lazy) && node.isLastNode
          }, className),
          style: style,
          "data-react": node[nodeKey],
          key: node[nodeKey]
        }, /*#__PURE__*/React.createElement("div", {
          className: classNames('roo-tree-node-content', {
            disabled: node.isDisabled,
            'roo-tree-is-selected': node.isSelected
          }),
          onClick: function onClick(evt) {
            _this.handleClick(evt, node);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "roo-tree-node-expand-icon"
        }), _this.renderCheckbox(node), /*#__PURE__*/React.createElement("div", {
          className: "roo-tree-node-label"
        }, _this.renderLabel(node, index))), node.hasChild ? /*#__PURE__*/React.createElement("div", {
          className: "roo-tree-node-children"
        }, _this.renderTree(node[nodeChildren])) : null);
      });
    };

    var data = _this.props.data;
    _this.state = {
      copyState: cloneLoop(data),
      stateTree: [],
      flatState: []
    };
    return _this;
  } // TODO: use getDerivedStateFromProps


  _createClass(Tree, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var isDataChange = !isEqual(nextProps.data, this.state.copyState);
      var isSelectedKeysChange = !isEqual(nextProps.selectedKeys, this.props.selectedKeys);
      var isSelectedKeyChange = !isEqual(nextProps.selectedKey, this.props.selectedKey);

      if (isDataChange || isSelectedKeysChange || isSelectedKeyChange) {
        this.tempDefaultCheckedNode = [];
        this.setState({
          copyState: cloneLoop(nextProps.data),
          flatState: []
        }, function () {
          var copyState = _this2.state.copyState;

          _this2.initStateTree(copyState);
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initStateTree();
    }
  }, {
    key: "render",
    value: function render() {
      var stateTree = this.state.stateTree;
      var treeDom = this.renderTree(stateTree);
      return treeDom;
    }
  }]);

  return Tree;
}(React.Component);

Tree.defaultProps = {
  data: [],
  nodeKey: 'id',
  nodeLabel: 'label',
  nodeChildren: 'children',
  showCheckbox: false,
  selectedKey: '',
  selectedKeys: [],
  lazy: false,
  defaultExpandAll: false,
  defaultExpandedKeys: undefined,
  lazyLoad: undefined,
  nodeRender: undefined,
  onNodeClick: undefined,
  onNodeExpand: undefined,
  onNodeCollapse: undefined,
  onCheckChange: undefined
};
Tree.propTypes = {
  nodeKey: PropTypes.string,
  nodeLabel: PropTypes.string,
  nodeChildren: PropTypes.string,
  data: PropTypes.array,
  showCheckbox: PropTypes.bool,
  selectedKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedKeys: PropTypes.array,
  lazy: PropTypes.bool,
  defaultExpandAll: PropTypes.bool,
  defaultExpandedKeys: PropTypes.array,
  lazyLoad: PropTypes.func,
  nodeRender: PropTypes.func,
  onNodeClick: PropTypes.func,
  onNodeExpand: PropTypes.func,
  onNodeCollapse: PropTypes.func,
  onCheckChange: PropTypes.func
};
export default Tree;